export enum BrowserFonts {
  Arial = 'Arial',
  AvantGarde = 'Avant Garde',
  Bookman = 'Bookman',
  Courier = 'Courier',
  CourierNew = 'Courier New',
  Garamond = 'Garamond',
  Helvetica = 'Helvetica',
  Palatino = 'Palatino',
  SystemUi = 'system-ui',
  Times = 'Times',
  TimesNewRoman = 'Times New Roman',
}

export enum GoogleFonts {
  Anton = 'Anton',
  Archivo = 'Archivo',
  Domine = 'Domine',
  Dosis = 'Dosis',
  DroidSans = 'Droid Sans',
  IBMPlexSans = 'IBM Plex Sans',
  Inter = 'Inter',
  Jost = 'Jost',
  Lato = 'Lato',
  Lora = 'Lora',
  Manrope = 'Manrope',
  Montserrat = 'Montserrat',
  NotoSansJP = 'Noto Sans JP',
  NotoSansTC = 'Noto Sans TC',
  Nunito = 'Nunito',
  NunitoSans = 'Nunito Sans',
  OpenSans = 'Open Sans',
  Oswald = 'Oswald',
  Outfit = 'Outfit',
  PTSans = 'PT Sans',
  PlayfairDisplay = 'Playfair Display',
  Poppins = 'Poppins',
  PublicSans = 'Public Sans',
  RedditSans = 'Reddit Sans',
  Roboto = 'Roboto',
  Rubik = 'Rubik',
  SourceSansPro = 'Source Sans Pro',
  SourceSerifPro = 'Source Serif Pro',
  SpaceGrotesk = 'Space Grotesk',
  Ubuntu = 'Ubuntu',
  WorkSans = 'Work Sans',
}
